// extracted by mini-css-extract-plugin
var _1 = "DisplayOptions_content__ae28f";
var _2 = "DisplayOptions_root__2ca47";
export { _1 as "content", _2 as "root" }
